module.exports = __webpack_public_path__ + "static/media/returnInApril_mbl.51c3aad1.png";